import { Link } from "react-router-dom";
import PublicShell from "../layout/PublicShell";

const UPDATED = "April 2026";

export default function Privacy() {
  return (
    <PublicShell minimal>
      <article className="max-w-[680px] mx-auto px-6 py-16 prose-ilmli">
        <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-ink-faint">
          legal · privacy
        </div>
        <h1 className="mt-3 font-serif text-3xl md:text-4xl leading-tight">
          What we keep, what we don't.
        </h1>
        <p className="mt-2 font-mono text-[11px] text-ink-faint">Last updated: {UPDATED}</p>

        <section className="mt-10 space-y-5 text-[15px] leading-relaxed text-ink-soft">
          <p>
            ilmli is a language tutor that lives in Telegram. To do that, we
            store the bare minimum about you. This page is the plain-English
            version; the legal contract is below.
          </p>

          <h2 className="font-serif text-xl text-ink mt-8">What we store</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>Your email + name (you gave them at signup).</li>
            <li>Your Telegram chat id (so the bot can reach you).</li>
            <li>Every message you and the bot exchange. Encrypted at rest.</li>
            <li>Your vocabulary record — which words you've seen, mastered, struggled with.</li>
            <li>Your settings — language, level, quiet hours, persona.</li>
            <li>Billing record (Stripe customer id + subscription state). Card details never touch our servers.</li>
          </ul>

          <h2 className="font-serif text-xl text-ink mt-8">What we don't do</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>We don't train models on your messages.</li>
            <li>We don't sell anything to anyone.</li>
            <li>We don't share data with advertisers — we don't run ads.</li>
            <li>We don't track you across other sites.</li>
          </ul>

          <h2 className="font-serif text-xl text-ink mt-8">Cookies</h2>
          <p>
            We use <em>one</em> cookie: a session token after you sign in, so we
            know it's still you on the next request. No analytics cookies, no
            third-party trackers, no advertising pixels.
          </p>

          <h2 className="font-serif text-xl text-ink mt-8">Your rights</h2>
          <p>
            Export your vocabulary as a CSV any time from{" "}
            <Link to="/app/profile" className="underline decoration-ink-faint/40 hover:decoration-terracotta">
              Settings → Account
            </Link>
            . Delete your account from the same page — that wipes every row keyed to you, immediately and permanently.
            Email <a href="mailto:hello@ilmli.ai" className="underline">hello@ilmli.ai</a> for anything else.
          </p>

          <h2 className="font-serif text-xl text-ink mt-8">Sub-processors</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li><strong>AWS</strong> (eu-central-1) — hosting, database, email.</li>
            <li><strong>Telegram</strong> — message delivery.</li>
            <li><strong>Stripe</strong> — billing.</li>
            <li><strong>OpenRouter</strong> — language-model inference for tutor replies.</li>
          </ul>

          <h2 className="font-serif text-xl text-ink mt-8">Contact</h2>
          <p>
            Privacy questions, deletion requests, anything else:{" "}
            <a href="mailto:hello@ilmli.ai" className="underline">hello@ilmli.ai</a>. A real person reads everything.
          </p>
        </section>

        <div className="mt-12 pt-6 border-t border-[rgba(42,36,26,0.12)] text-[13px] text-ink-faint">
          See also: <Link to="/terms" className="underline decoration-ink-faint/40 hover:decoration-terracotta">Terms</Link>{" "}
          · <Link to="/" className="underline decoration-ink-faint/40 hover:decoration-terracotta">Home</Link>
        </div>
      </article>
    </PublicShell>
  );
}
